/** VERSION: 0.0.1 Please do not delete this line. Thank you! **/
if (typeof lazySizes !== 'function') {
  /*! lazysizes - v4.1.8 */
  !(function (a, b) { const c = b(a, a.document); a.lazySizes = c, typeof module === 'object' && module.exports && (module.exports = c) }(window, function (a, b) { 'use strict'; if (b.getElementsByClassName) { let c; let d; const e = b.documentElement; const f = a.Date; const g = a.HTMLPictureElement; const h = 'addEventListener'; const i = 'getAttribute'; const j = a[h]; const k = a.setTimeout; const l = a.requestAnimationFrame || k; const m = a.requestIdleCallback; const n = /^picture$/i; const o = ['load', 'error', 'lazyincluded', '_lazyloaded']; const p = {}; const q = Array.prototype.forEach; const r = function (a, b) { return p[b] || (p[b] = new RegExp('(\\s|^)' + b + '(\\s|$)')), p[b].test(a[i]('class') || '') && p[b] }; const s = function (a, b) { r(a, b) || a.setAttribute('class', (a[i]('class') || '').trim() + ' ' + b) }; const t = function (a, b) { let c; (c = r(a, b)) && a.setAttribute('class', (a[i]('class') || '').replace(c, ' ')) }; var u = function (a, b, c) { const d = c ? h : 'removeEventListener'; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }; const v = function (a, d, e, f, g) { const h = b.createEvent('Event'); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }; const w = function (b, c) { let e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]('srcset') && b.setAttribute('srcset', c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }; const x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }; const y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }; const z = (function () { let a; let c; const d = []; const e = []; let f = d; const g = function () { const b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }; const h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }()); const A = function (a, b) { return b ? function () { z(a) } : function () { const b = this; const c = arguments; z(function () { a.apply(b, c) }) } }; const B = function (a) { let b; let c = 0; const e = d.throttleDelay; let g = d.ricTimeout; const h = function () { b = !1, c = f.now(), a() }; const i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { let d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }; const C = function (a) { let b; let c; const d = 99; const e = function () { b = null, a() }; var g = function () { const a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !(function () { let b; const c = { lazyClass: 'lazyload', loadedClass: 'lazyloaded', loadingClass: 'lazyloading', preloadClass: 'lazypreload', errorClass: 'lazyerror', autosizesClass: 'lazyautosizes', srcAttr: 'data-src', srcsetAttr: 'data-srcset', sizesAttr: 'data-sizes', minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: 0.8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }()); const D = (function () { let g; let l; let m; let o; let p; let y; let D; let F; let G; let H; let I; let J; const K = /^img$/i; const L = /^iframe$/i; const M = 'onscroll' in a && !/(gle|ing)bot/.test(navigator.userAgent); const N = 0; let O = 0; let P = 0; let Q = -1; const R = function (a) { P--, (!a || P < 0 || !a.target) && (P = 0) }; const S = function (a) { return J == null && (J = x(b.body, 'visibility') == 'hidden'), J || x(a.parentNode, 'visibility') != 'hidden' && x(a, 'visibility') != 'hidden' }; const T = function (a, c) { let d; let f = a; let g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, 'opacity') || 1) > 0) && x(f, 'overflow') != 'visible' && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }; const U = function () { let a; let f; let h; let j; let k; let m; let n; let p; let q; let r; let s; let t; const u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++) if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]('data-expand')) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || u[f][i](d.sizesAttr) != 'auto')) && (j = g[0] || u[f]); j && !k && aa(j) } }; const V = B(U); const W = function (a) { const b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, 'lazyloaded') }; const X = A(W); var Y = function (a) { X({ target: a.target }) }; const Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }; const $ = function (a) { let b; const c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]('data-media') || a[i]('media')]) && a.setAttribute('media', b), c && a.setAttribute('srcset', c) }; const _ = A(function (a, b, c, e, f) { let g, h, j, l, o, p; (o = v(a, 'lazybeforeunveil', b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute('sizes', e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || '')), p = b.firesLoad || 'src' in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName('source'), $), h ? a.setAttribute('srcset', h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { const b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, 'ls-is-cached'), W(o), a._lazyCache = !0, k(function () { '_lazyCache' in a && delete a._lazyCache }, 9)), a.loading == 'lazy' && P-- }, !0) }); var aa = function (a) { if (!a._lazyRace) { let b; const c = K.test(a.nodeName); const e = c && (a[i](d.sizesAttr) || a[i]('sizes')); const f = e == 'auto'; (!f && l || !c || !a[i]('src') && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, 'lazyunveilread').detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++, _(a, b, f, e, c)) } }; const ba = C(function () { d.loadMode = 3, V() }); const ca = function () { d.loadMode == 3 && (d.loadMode = 2), ba() }; var da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j('scroll', ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + ' ' + d.preloadClass), j('scroll', V, !0), j('resize', V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]('DOMNodeInserted', V, !0), e[h]('DOMAttrModified', V, !0), setInterval(V, 999)), j('hashchange', V, !0), ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j('load', da), b[h]('DOMContentLoaded', V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }()); var E = (function () { let a; const c = A(function (a, b, c, d) { let e, f, g; if (a._lazysizesWidth = d, d += 'px', a.setAttribute('sizes', d), n.test(b.nodeName || '')) for (e = b.getElementsByTagName('source'), f = 0, g = e.length; f < g; f++)e[f].setAttribute('sizes', d); c.detail.dataAttr || w(a, c.detail) }); const e = function (a, b, d) { let e; const f = a.parentNode; f && (d = y(a, f, d), e = v(a, 'lazybeforesizes', { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }; const f = function () { let b; const c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }; const g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j('resize', g) }, checkElems: g, updateElem: e } }()); var F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } }))
  /*! ls.rias.min.ks - v4.1.8 */
  !(function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener('lazyunveilread', c, !0) }; b = b.bind(null, a, a.document), typeof module === 'object' && module.exports ? b(require('lazysizes')) : a.lazySizes ? c() : a.addEventListener('lazyunveilread', c, !0) }(window, function (a, b, c) { 'use strict'; function d (b, c) { let d; let e; let f; let g; const h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || '')) }, f = function (a, c) { let d = b.getAttribute('data-' + a); if (!d) { const e = h.getPropertyValue('--ls-' + a); e && (d = e.trim()) } if (d) { if (d == 'true') d = !0; else if (d == 'false') d = !1; else if (l.test(d)) d = parseFloat(d); else if (typeof j[a] === 'function') d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && typeof j[a] !== 'function' ? g[a] = j[a] : c && typeof j[a] === 'function' && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e (a, b) { const c = []; const d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute('href', a), a = s.href), a = ((b.prefix || '') + a + (b.postfix || '')).replace(p, d), b.widths.forEach(function (d) { const e = b.widthmap[d] || d; const f = b.aspectratio || b.ratio; const g = !b.aspectratio && j.traditionalRatio; const h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ''), w: d }; c.push(h), c.srcset.push(h.c = h.u + ' ' + d + 'w') }), c } function f (a, c, d) { let f = 0; let g = 0; let h = d; if (a) { if (c.ratio === 'container') { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && d.nodeName.toUpperCase() == 'IMG' ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(', ')), Object.defineProperty(d, '_lazyrias', { value: a, writable: !0 }) } } function g (a, b) { const e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, 'lazyriasmodifyoptions', e), e } function h (a) { return a.getAttribute(a.getAttribute('data-srcattr') || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute('data-pfsrcset') || '' } let i; let j; var k = { string: 1, number: 1 }; var l = /^\-*\+*\d+\.*\d*$/; var m = /^picture$/i; var n = /\s*\{\s*width\s*\}\s*/i; var o = /\s*\{\s*height\s*\}\s*/i; var p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi; var q = /^\[.*\]|\{.*\}$/; const r = /^(?:auto|\d+(px)?)$/; var s = b.createElement('a'); const t = b.createElement('img'); var u = 'srcset' in t && !('sizes' in t); const v = !!a.HTMLPictureElement && !u; !(function () { let b; const d = function () { }; const e = { prefix: '', postfix: '', srcAttr: 'data-src', absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), 'widths' in (j = i.rias) || (j.widths = [], (function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths))); for (b in e) b in j || (j[b] = e[b]) }()), addEventListener('lazybeforesizes', function (a) { if (a.detail.instance == c) { let b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute('sizes')) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName('source'), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, '_lazyrias', { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : q != 'auto' && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = (function () { const d = function (a, b) { return a.w - b.w }; const e = function (a) { let b; let c; const d = a.length; let e = a[d - 1]; let f = 0; for (f; f < d; f++) if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - 0.13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - 0.6, 1.6), b.cached && (b.d += 0.15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }; const f = function (a, b) { let d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ''))).length && (Object.defineProperty(a, '_lazyrias', { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = a.parentNode.nodeName.toUpperCase() == 'PICTURE')), a._lazyrias }; const g = function (b) { const d = a.devicePixelRatio || 1; const e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }; const h = function (b, c) { let h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName('source'), j = h.length; i < j; i++) if (f(h[i]) && !h[i].getAttribute('type') && (!(k = h[i].getAttribute('media')) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }; var j = function (d) { if (d.detail.instance == c) { let e; const g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener('lazybeforesizes', j); ('_lazyrias' in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute('src', e.u) })) } }; return v ? j = function () { } : addEventListener('lazybeforesizes', j), j }()) }))
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false
// Override Settings
const boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false,
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
    enableOTP: true,
    separateRefineByFromFilter: true,
    filterTreeMobileStyle: 'style3', // 'style2', 'style3',
    equal_height: boostPFSThemeConfig.custom.equal_height,
    cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.equal_height_crop_image_position,
    defaultDisplay: boostPFSThemeConfig.custom.product_item_type
  },
  selector: {
    // otpButtons: '.boost-pfs-filter-product-item-image'
  }
};

(function () {
  let onSale = false
  let soldOut = false
  let priceVaries = false
  let images = []
  let firstVariant = {}
  const boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
  const boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]

  BoostPFS.inject(this)

  /** ************************ CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData (data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
    priceVaries = data.price_min != data.price_max // Check a product has many prices
    // Convert images to array
    images = data.images_info
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data.variants[0]
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      const paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant')
      })
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      for (let i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          firstVariant = data.variants[i]
          break
        }
      }
    }
    return data
  }

  /** ************************ END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /** ************************ BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data
    // Hide products tagged COLLECTION_HIDE (bandaid for Boost sync issue)
    // if (data.tags && Array.from(data.tags).includes('COLLECTION_HIDE')) return ''
    // On event planner collections, only show products with POC-SHOW tag
    // if (window.location.href.indexOf('event-planner-collection') >= 0 && data.tags && !Array.from(data.tags).includes('POC-SHOW')) return ''
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data)

    // Get Template
    let itemHtml = boostPFSTemplate.productGridItemHtml
    // Add Custom class
    const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : ''
    const saleClass = onSale ? boostPFSTemplate.saleClass : ''
    // Format title if data.tags contains 'COLLECTION_HIDE'
    const productTags = Array.from(data.tags)
    let productTitle = data.title
    if (productTags.includes('COLLECTION_SHOW') && productTitle.includes('Slim Fit')) {
      productTitle = productTitle.replace('Slim Fit', '').trim()
    } else if (productTags.includes('COLLECTION_SHOW') && productTitle.includes('Modern Fit')) {
      productTitle = productTitle.replace('Modern Fit', '').trim()
    }
    if (productTitle === 'Suit' || productTitle === 'Solid Suit' || productTitle === 'Wool Suit') {
      let mergedColorVariant = data.variants[0].original_merged_options[0].split(':')[1].trim()
      // Make the color variant lower case and capitalize the first letter of each word if there are multiple words
      const colorWords = mergedColorVariant.split(' ')
      const capitalizedColorWords = colorWords.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      mergedColorVariant = capitalizedColorWords.join(' ')
      if (productTitle !== 'Wool Suit') {
        productTitle = productTitle.replace(productTitle, mergedColorVariant + ' Suit')
      } else {
        productTitle = productTitle.replace(productTitle, mergedColorVariant + ' Wool Suit')
      }
      if (productTitle === 'Suit' || productTitle === mergedColorVariant + ' Suit') {
        productTitle = productTitle.replace('Suit', 'Solid Suit')
      }
    }

    // Add Grid Width class
    itemHtml = itemHtml.replace(/{{gridWidthClass}}/g, buildGridWidthClass(data))
    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false))
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data))
    // Add Sale badge
    itemHtml = itemHtml.replace(/{{itemSaleBadge}}/g, buildSaleBadge(data))
    // Add Sustainability badge
    itemHtml = itemHtml.replace(/{{itemSustainabilityBadge}}/g, buildSustainabilityBadge(data))

    // Add Meta
    itemHtml = itemHtml.replace(/{{itemMeta}}/g, buildMeta(data))

    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data))

    // Add upgrade badge
    itemHtml = itemHtml.replace(/{{itemUpgradeBadge}}/g, buildUpgradeBadge(data))

    // Add seasonal badge
    itemHtml = itemHtml.replace(/{{itemSeasonalBadge}}/g, buildSeasonalBadge(data))

    // Add core badge
    itemHtml = itemHtml.replace(/{{itemCoreBadge}}/g, buildCoreBadge(data))

    // Add Review
    if (typeof Integration === 'undefined' ||
			(typeof Integration !== 'undefined' &&
				typeof Integration.hascompileTemplate === 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data))
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data))
    itemHtml = itemHtml.replace(/{{itemVendorUrl}}/g, buildVendorUrl(data))

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data))

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, productTitle)
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data))
    return itemHtml
  }

  // Build Product List Item
  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data
    // Hide products tagged COLLECTION_HIDE (bandaid for Boost sync issue)
    // if (data.tags && Array.from(data.tags).includes('COLLECTION_HIDE')) return ''
    // On event planner collections, only show products with POC-SHOW tag
    // if (window.location.href.indexOf('event-planner-collection') >= 0 && data.tags && !Array.from(data.tags).includes('POC-SHOW')) return ''
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data)

    // For List View
    // Get Template
    let itemHtml = boostPFSTemplate.productListItemHtml

    // Add Custom class
    const soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : ''
    const saleClass = onSale ? boostPFSTemplate.saleClass : ''

    // Add Label
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data))
    // Add TAG Label
    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, buildTagLabels(data, false))
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data))
    // Add Sale badge
    itemHtml = itemHtml.replace(/{{itemSaleBadge}}/g, buildSaleBadge(data))
    // Add Sustainability badge
    itemHtml = itemHtml.replace(/{{itemSustainabilityBadge}}/g, buildSustainabilityBadge(data))

    // Add Review
    if (typeof Integration === 'undefined' ||
			(typeof Integration !== 'undefined' &&
				typeof Integration.hascompileTemplate === 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data))
    }

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data))

    // Add Price
    const itemPriceHtml = buildPrice(data, onSale, priceVaries)
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml)

    // Description
    let itemDescription = jQ('<p>' + data.body_html + '</p>').text()
    itemDescription = (itemDescription.split(' ')).length > 35 ? itemDescription.split(' ').splice(0, 35).join(' ') + '...' : itemDescription.split(' ').splice(0, 35).join(' ')
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription)

    // itemActiveSwapClass
    itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data))

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor)
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data))
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)

    return itemHtml
    // End For List View
  }

  /** ************************ END BUILD PRODUCT LIST **************************/
  /** ************************ BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildGridWidthClass () {
    let gridWidthClass = ''
    // On PC
    switch (boostPFSThemeConfig.custom.products_per_row) {
      case 2:
        gridWidthClass = 'boost-pfs-filter-grid-width-2'
        break
      case 3:
        gridWidthClass = 'boost-pfs-filter-grid-width-3'
        break
      case 5:
        gridWidthClass = 'boost-pfs-filter-grid-width-5'
        break
      case 6:
        gridWidthClass = 'boost-pfs-filter-grid-width-6'
        break
      default:
        gridWidthClass = 'boost-pfs-filter-grid-width-4'
        break
    }
    // On Mobile
    switch (boostPFSThemeConfig.custom.products_per_row_mobile) {
      case 1:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-1'
        break
      case 3:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-3'
        break
      default:
        gridWidthClass += ' boost-pfs-filter-grid-width-mb-2'
        break
    }
    return gridWidthClass
  }

  function buildImages (data) {
    let html = ''
    let aspectRatio = ''
    const rangeWidths = boostPFSRangeWidths
    let paddingTop = 100

    let dataSrcSet = ''
    let dataWidths = ''
    const dataSizes = 'auto'
    const imgAlt = data.title
    let flipImageSrcSet = ''

    let hoverImageSrcSet = ''
    const activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true

    // Check for product videos
    const productMedia = data.media.filter(media => media.mediaContentType == 'VIDEO')

    for (let i = 0; i < rangeWidths.length; i++) {
      dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w'
      dataWidths += rangeWidths[i]

      if (images.length > 1) {
        if (productMedia.length > 0 && data.media[0].id === productMedia[0].id) {
          hoverImageSrcSet += Utils.optimizeImage(images[0].src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w'
        } else {
          hoverImageSrcSet += Utils.optimizeImage(images[1].src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w'
        }
      } else {
        hoverImageSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w'
      }

      if (i < rangeWidths.length - 1) {
        dataSrcSet += ', '
        hoverImageSrcSet += ', '
        dataWidths += ', '

        if (activeSwapImage) {
          flipImageSrcSet += ', '
        }
      }
    }

    if (images.length > 0) {
      aspectRatio = images[0].width / images[0].height
      paddingTop = 1 / aspectRatio * 100
    }

    const itemProp = document.body.classList.contains('theme-tip-top') ? 'itemprop="image"' : ''

    html += '<a href="{{itemUrl}}" class="image-link" data-collection-item-link>'
    html += '<img class="boost-pfs-filter-product-item-main-image lazyload Image--lazyLoad"' +
			itemProp +
			'data-srcset="' + dataSrcSet + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, rangeWidths[2] + 'x') + '" ' +
			'data-widths="[' + dataWidths + ']" ' +
			'data-sizes="' + dataSizes + '" ' +
			'src="' + boostPFSImgDefaultSrc + '" ' +
			'alt="' + imgAlt + '" '

    if (activeSwapImage) {
      if (productMedia.length > 0 && data.media[0].id === productMedia[0].id) {
        html += 'data-img-flip-src="' + Utils.optimizeImage(images[0].src, rangeWidths[2] + 'x') + '" ' +
					'data-img-flip-srcset="' + flipImageSrcSet + '" '
      } else {
        html += 'data-img-flip-src="' + Utils.optimizeImage(images[1].src, rangeWidths[2] + 'x') + '" ' +
					'data-img-flip-srcset="' + flipImageSrcSet + '" '
      }
    }

    html += '/>'

    // Only use video if it is first media item
    if (productMedia.length > 0 && data.media[0].id === productMedia[0].id) {
      html += '<video class="collection__item-video" width="100%" height="100%" playsinline muted autoplay loop>' +
				'<source src="' +
				productMedia[0].sources[2].url +
				'" type="video/mp4"></video>'
    }

    if (images.length > 1) {
      let hoverImageSrc = Utils.optimizeImage(images[1].src, rangeWidths[2] + 'x')
      if (productMedia.length > 0 && data.media[0].id === productMedia[0].id) {
        hoverImageSrc = Utils.optimizeImage(images[0].src, rangeWidths[2] + 'x')
      }

      html += '<img class="boost-pfs-filter-product-item-main-image collection__item-secondary-image lazyload Image--lazyLoad" ' +
			'data-collection-item-hover data-srcset="' + hoverImageSrcSet + '" ' +
			'data-src="' + hoverImageSrc + '" ' +
			'data-widths="[' + dataWidths + ']" ' +
			'data-sizes="' + dataSizes + '" ' +
			'src="' + boostPFSImgDefaultSrc + '" ' +
			'alt="' + imgAlt + '" />'

      // Secondary video - Only use if it is second media item
      if (data.media.length > 1 && data.media[1].mediaContentType === 'VIDEO') {
        html += '<video class="collection__item-secondary-video" width="100%" height="100%" playsinline muted autoplay loop>' +
				'<source src="' +
				data.media[1].sources[2].url +
				'" type="video/mp4"></video>'
      }

      html += '</a>'
    } else {
      html += '</a>'
    }

    return html
  }

  function buildSaleBadge (data) {
    let html = ''
    if (data.tags.includes('best-seller')) {
      html += `<span class="collection__item-badge badge-bestseller" data-collection-item-badge><span class="medium-down--hide">${theme.strings.bestseller}</span><span class="large--hide" aria-hidden="true">${theme.strings.bestsellerMobile}</span></span>`
    } else {
      if (data.product_type == 'Suit Bundle' && data.tags.includes('new-arrival')) {
        html += `<span class="collection__item-badge" data-collection-item-badge>${theme.strings.new}</span>`
      } else if (data.compare_at_price_min > data.price_min) {
        const percentOff = ((data.compare_at_price_min - data.price_min) / data.compare_at_price_min) * 100.0
        html += `<span class="collection__item-badge badge-sale" data-collection-item-badge>${percentOff.toFixed(0)}% ${theme.strings.off}</span>`
      } else if (data.tags.includes('new-arrival')) {
        html += `<span class="collection__item-badge" data-collection-item-badge>${theme.strings.new}</span>`
      }
    }
    return html
  }

  function buildSustainabilityBadge (data) {
    let html = ''
    if (data.tags.includes(theme.strings.sustainabilityTag) && theme.strings.sustainabilityIcon != '') {
      html = `<span class="collection__item-sustainable"><img src="${theme.strings.sustainabilityIcon}" class="lazyload" alt="Sustainable Product Badge" data-src="${theme.strings.sustainabilityIcon}"></span>`
    }
    return html
  }

  function buildMeta (data) {
    if (!document.body.classList.contains('theme-tip-top')) { return }

    const html = `
			<div style="display: none;" itemprop="offers" itemscope="" itemtype="//schema.org/Offer">
				<meta itemprop="price" content="${data.variants[0].price}">
				<meta itemprop="priceCurrency" content="USD">
				<meta itemprop="productID" content="${data.id}">
				<meta itemprop="availability" content="http://schema.org/InStock">
				<meta itemprop="url" content="${window.location.hostname}/products/${data.handle}">
				<meta itemprop="color" content="${data.variants[0].title}">
				<meta itemprop="brand" content="${data.vendor}">
				<meta itemprop="description " content="${data.description ? data.description.replace(/"/g, '&quot;') : ''}">
			</div>
		`

    return html
  }

  function buildVendor (data) {
    let html = ''
    html = boostPFSTemplate.vendorHtml.replace(/\{\{itemVendor\}\}/g, data.vendor)
    return html
  }

  function buildVendorUrl (data) {
    let html = ''
    html = data.vendor.toLowerCase().replace(' ', '-')
    return html
  }

  function buildPrice (data) {
    const priceDisplay = (data.price_min === data.price_max) ? Utils.formatMoney(data.price_min) : `${Utils.formatMoney(data.price_min)} - ${Utils.formatMoney(data.price_max)}`

    let html = ''
    html = '<p class="collection__item-price xlarge--text-right">'

    if (onSale) {
      html += '<b>' + priceDisplay + '</b>'
      html += '<s>' + Utils.formatMoney(data.compare_at_price_min) + '</s> '
    } else {
      html += priceDisplay
    }
    html += '</p>'
    return html
  }

  function buildLabels (data) {
    // Build Sold out label
    let soldOutLabel = ''
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_sold_out_label') &&
			boostPFSThemeConfig.custom.show_sold_out_label && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{style}}/g, '')
    }
    // Build Sale label
    let saleLabel = ''
    if (boostPFSThemeConfig.custom.show_sale_label && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{style}}/g, '')
    }
    // Build Labels
    return soldOutLabel + saleLabel
  }

  // BUILD LABEL PRODUCT WITH TAGS
  function buildTagLabels (data, showall) {
    if (boostPFSThemeConfig.custom.show_lable_by_tag) {
      if (showall) {
        var tagLabel = ''
        if (data.tags) {
          for (var i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i]
            if (tag.indexOf('pfs:label') !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1])
              tagLabel += preTagLabel
            }
          }
        }
      } else {
        var tagLabel = ''
        if (data.tags) {
          for (var i = data.tags.length - 1; i >= 0; i--) {
            tag = data.tags[i]
            if (tag.indexOf('pfs:label') !== -1) {
              var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1])
              tagLabel += preTagLabel
              break
            }
          }
        }
      }
      return tagLabel
    } else {
      return ''
    }
  }

  function buildReview (data) {
    let html = ''
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
      html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
    }
    return html
  }

  function buildActiveSwapClass (data) {
    if (!Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
			boostPFSThemeConfig.custom.active_image_swap == true) {
      return 'has-bc-swap-image'
    }
    return ''
  }

  function buildUpgradeBadge (data) {
    let html = ''
    if (window.location.href.indexOf('event-planner-collection') >= 0) {
      html = `
				<upgrade-badge class="hide" data-upgrade-product-type="${data.product_type}" data-upgrade-product-title="${data.title}" data-upgrade-product-price="${data.price_min}">
					<div class="collection-item__upgrade-badge label label--small">
						${window.theme.strings.upgrade}
						<span data-upgrade-badge-value></span>
					</div>
				</upgrade-badge>
			`
    }
    return html
  }

  function buildSeasonalBadge (data) {
    let html = ''
    if (window.location.href.indexOf('event-planner-collection') >= 0) {
      html = `
				<seasonal-badge ${!data.tags.includes('seasonal') ? 'class="hide"' : ''}>
					<button class="collection-item__seasonal-badge label label--small">
						${window.theme.strings.seasonal}
					</button>
				</seasonal-badge>
			`
    }
    return html
  }

  function buildCoreBadge (data) {
    let html = ''
    if (window.location.href.indexOf('event-planner-collection') >= 0) {
      html = `
				<core-badge ${!data.tags.includes('core') ? 'class="hide"' : ''}>
					<button class="collection-item__core-badge">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M19.5277 7.84858L11.5 12.3085M11.5 12.3085L3.47219 7.84858M11.5 12.3085L11.5 21.2807M20 16.1416V8.4754C20 8.1518 20 7.98999 19.9523 7.84568C19.9101 7.71802 19.8412 7.60083 19.7501 7.50195C19.6471 7.39019 19.5056 7.31161 19.2227 7.15445L12.2339 3.27174C11.966 3.12293 11.8321 3.04853 11.6903 3.01936C11.5647 2.99355 11.4353 2.99355 11.3097 3.01936C11.1679 3.04853 11.034 3.12293 10.7661 3.27174L3.77725 7.15446C3.49437 7.31161 3.35293 7.39019 3.24993 7.50196C3.15882 7.60083 3.08986 7.71802 3.04768 7.84568C3 7.98999 3 8.1518 3 8.4754V16.1416C3 16.4652 3 16.627 3.04768 16.7713C3.08986 16.8989 3.15882 17.0161 3.24993 17.115C3.35293 17.2268 3.49437 17.3054 3.77725 17.4625L10.7661 21.3452C11.034 21.494 11.1679 21.5684 11.3097 21.5976C11.4353 21.6234 11.5647 21.6234 11.6903 21.5976C11.8321 21.5684 11.966 21.494 12.2339 21.3452L19.2227 17.4625C19.5056 17.3054 19.6471 17.2268 19.7501 17.115C19.8412 17.0161 19.9101 16.8989 19.9523 16.7713C20 16.627 20 16.4652 20 16.1416Z" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M10.7661 3.27174C11.034 3.12293 11.1679 3.04853 11.3097 3.01936C11.4353 2.99355 11.5647 2.99355 11.6903 3.01936C11.8321 3.04853 11.966 3.12293 12.2339 3.27174L19.2227 7.15445C19.5056 7.31161 19.6471 7.39019 19.7501 7.50195C19.8412 7.60083 19.9101 7.71802 19.9523 7.84568C20 7.98999 20 8.1518 20 8.4754V16.1416C20 16.4652 20 16.627 19.9523 16.7713C19.9101 16.8989 19.8412 17.0161 19.7501 17.115C19.6471 17.2268 19.5056 17.3054 19.2227 17.4625L12.2339 21.3452C11.966 21.494 11.8321 21.5684 11.6903 21.5976C11.5647 21.6234 11.4353 21.6234 11.3097 21.5976C11.1679 21.5684 11.034 21.494 10.7661 21.3452L3.77725 17.4625C3.49437 17.3054 3.35293 17.2268 3.24993 17.115C3.15882 17.0161 3.08986 16.8989 3.04768 16.7713C3 16.627 3 16.4652 3 16.1416V8.4754C3 8.1518 3 7.98999 3.04768 7.84568C3.08986 7.71802 3.15882 7.60083 3.24993 7.50196C3.35293 7.39019 3.49437 7.31161 3.77725 7.15446L10.7661 3.27174Z" fill="white"/>
							<path d="M19.5277 7.84858L11.5 12.3085M11.5 12.3085L3.47219 7.84858M11.5 12.3085L11.5 21.2807M20 16.1416V8.4754C20 8.1518 20 7.98999 19.9523 7.84568C19.9101 7.71802 19.8412 7.60083 19.7501 7.50195C19.6471 7.39019 19.5056 7.31161 19.2227 7.15445L12.2339 3.27174C11.966 3.12293 11.8321 3.04853 11.6903 3.01936C11.5647 2.99355 11.4353 2.99355 11.3097 3.01936C11.1679 3.04853 11.034 3.12293 10.7661 3.27174L3.77725 7.15446C3.49437 7.31161 3.35293 7.39019 3.24993 7.50196C3.15882 7.60083 3.08986 7.71802 3.04768 7.84568C3 7.98999 3 8.1518 3 8.4754V16.1416C3 16.4652 3 16.627 3.04768 16.7713C3.08986 16.8989 3.15882 17.0161 3.24993 17.115C3.35293 17.2268 3.49437 17.3054 3.77725 17.4625L10.7661 21.3452C11.034 21.494 11.1679 21.5684 11.3097 21.5976C11.4353 21.6234 11.5647 21.6234 11.6903 21.5976C11.8321 21.5684 11.966 21.494 12.2339 21.3452L19.2227 17.4625C19.5056 17.3054 19.6471 17.2268 19.7501 17.115C19.8412 17.0161 19.9101 16.8989 19.9523 16.7713C20 16.627 20 16.4652 20 16.1416Z" stroke="#B2AFC2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M3 8.6665L11.5 12.4443L11.0278 20.9443L3 17.1665V8.6665Z" fill="#B2AFC2"/>
							<path fill-rule="evenodd" clip-rule="evenodd" d="M10.0711 13.8284L8.65685 12.4142L5.82842 15.2426L4.41421 13.8284L3 15.2426L4.41421 16.6569L5.82842 18.0711L7.24264 16.6569L10.0711 13.8284Z" fill="white"/>
						</svg>
					</button>
				</core-badge>
			`
    }
    return html
  }

  /** ************************ END BUILD PRODUCT ITEM ELEMENTS **************************/
  /** ************************ BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    const currentPage = parseInt(Globals.queryParams.page)
    const totalPage = Math.ceil(totalProduct / Globals.queryParams.limit)
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return ''
    }

    let paginationHtml = boostPFSTemplate.paginateHtml
    // Build Previous
    let previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1))
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)
    // Build Next
    let nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1))
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)
    // Create page items array
    const beforeCurrentPageArr = []
    for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore)
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...')
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1)
    }
    beforeCurrentPageArr.push(currentPage)
    const afterCurrentPageArr = []
    for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter)
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...')
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage)
    }
    // Build page items
    let pageItemsHtml = ''
    const pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
    for (let iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]))
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)
    return paginationHtml
  }

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    let html = ''
    if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      const sortingArr = Utils.getSortingList()
      if (sortingArr) {
        const paramSort = Globals.queryParams.sort || ''
        // Build content
        let sortingItemsHtml = ''
        for (const k in sortingArr) {
          activeClass = ''
          if (paramSort == k) {
            activeClass = 'boost-pfs-filter-sort-item-active'
          }
          sortingItemsHtml += '<li><a href="#" data-sort="' + k + '" class="' + activeClass + '">' + sortingArr[k] + '</a></li>'
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml)
      }
    }
    return html
  }

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate())

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active')
    }

    let labelSort = ''
    const paramSort = Globals.queryParams.sort || ''
    const sortingList = Utils.getSortingList()
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort]
    } else {
      labelSort = Labels.sorting_heading
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort)
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    const _this = this
    jQ('.boost-pfs-filter-filter-dropdown a').click(function (e) {
      e.preventDefault()
      FilterApi.setParam('sort', jQ(this).data('sort'))
      FilterApi.setParam('page', 1)
      FilterApi.applyFilter('sort')
    })

    jQ('.boost-pfs-filter-custom-sorting > button').click(function () {
      if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
        jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active')
      }
    })

    jQ(Selector.filterTreeMobileButton).click(function () {
      jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide()
    })
  }
  // For Toolbar - Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    let itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>'
    if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>'
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'
    } else {
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>'
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>'
    }

    itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType)

    return itemHtml
  }

  // Build Show Limit
  ProductLimit.prototype.compileTemplate = function () {
    let html = ''
    if (boostPFSThemeConfig.custom.show_limit && boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
      const numberList = Settings.getSettingValue('general.showLimitList')
      if (numberList != '') {
        // Build content
        let showLimitItemsHtml = ''
        const arr = numberList.split(',')
        for (const k in sortingArr) {
          showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>'
        }
        html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml)
      }
    }
    return html
  }
  // Build Breadcrumb
  Breadcrumb.prototype.compileTemplate = function (colData) {
    if (!colData) colData = this.collectionData
    let breadcrumbItemsHtml = ''
    if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
      if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        const colInfo = colData.collection
        if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title)
          breadcrumbItemsHtml += ' {{breadcrumbDivider}} '
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0])
        } else {
          breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title)
        }
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'))
      }
    }
    return breadcrumbItemsHtml
  }

  /** ************************ END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data

    // Intergrate Review Shopify
    if (window.SPR &&
			typeof window.SPR.initDomEls === 'function' &&
			typeof window.SPR.loadBadges === 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
      window.SPR.initDomEls()
      window.SPR.loadBadges()
    }
  }

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data

    let totalProduct = `${data.total_product} ${boostPFSThemeConfig.label.items_with_count_other}`

    if (data.total_product == 1) {
      totalProduct = `${data.total_product} ${boostPFSThemeConfig.label.items_with_count_one}`
    }
    jQ('.boost-pfs-filter-total-product').html(totalProduct)
    jQ('.boost-pfs-filter-mobile-toolbar-header').html(`Filters <span>${totalProduct}</span>`)
    jQ('.boost-pfs-filter-show-result').html(`Show Results (${data.total_product})`)

    jQ('body').find('.boost-pfs-filter-skeleton-button').remove()

    // Prevent double tap on iOS
    const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    if (isiOS) {
      Utils.isMobile() && jQ('.boost-pfs-filter-product-item').find('a').on('touchstart', function () {
        isScrolling = !1
      }).on('touchmove', function () {
        isScrolling = !0
      }).on('touchend', function () {
        isScrolling || (window.location = jQ(this).attr('href'))
      })
    }

    // Build Image Swap. Put this function here to impprove the pagespeed.
    swapImage(data)

    if (typeof boostRemoveImageLoadingAnimation === 'function') {
      boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'))
    }
  }

  ProductListPlaceholder.prototype.render = function () {
    // Set limit number for product skeleton
    const placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow
    // Build placeholder items
    const placeholderItem = this.compileTemplate()
    this.$element = []
    for (let i = 0; i < placeholderLimit; i++) {
      this.$element.push(jQ(placeholderItem))
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
      this.setShow()
    } else {
      this.setHide()
    }
  }

  ProductListPlaceholder.prototype.compileTemplateExtra = function () {
    const display = Globals.queryParams.display
    switch (display) {
      case 'list':
        // Todo: Build placeholder for List mode
        var template = boostPFSTemplate.productListPlaceholderHtml
        var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio)
        var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4 // It mean w1:h1.4
        /**
				 * Set product class for product skeleton (to set column, style, etc.)
				 * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
				 */
        break
    }
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100)
  }

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function (a, b) {}

  // Swap Image
  function swapImage (data) {
    if (!Utils.isMobile()) {
      if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
				boostPFSThemeConfig.custom.active_image_swap == true) {
        let dataSrcSetFlipImg = ''
        let dataSrcFlipImg = ''
        let flipImageAlt = ''
        const dataSizes = 'auto'
        let dataWidths = ''
        let html = ''

        jQ('.boost-pfs-filter-product-item').each(function () {
          const productItemSelector = jQ(this)
          const imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image')

          if (typeof imgSelector.data('img-flip-src') !== 'undefined' &&
						imgSelector.data('img-flip-src') != '') {
            dataSrcFlipImg = imgSelector.data('img-flip-src')
            dataSrcSetFlipImg = imgSelector.data('img-flip-srcset')
            flipImageAlt = imgSelector.attr('alt')
            dataWidths = imgSelector.data('widths')
            html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
							'data-srcset="' + dataSrcSetFlipImg + '" ' +
							'data-src="' + dataSrcFlipImg + '" ' +
							'data-widths="[' + dataWidths + ']" ' +
							'data-sizes="' + dataSizes + '" ' +
							'src="' + boostPFSImgDefaultSrc + '" ' +
							'alt="' + flipImageAlt + '" />'

            productItemSelector.find('.boost-pfs-filter-product-item-image-link').prepend(html)
          }
        })
      }
    }
  }

  // Build Placeholder for the first load
  function boostRemoveImageLoadingAnimation ($selector) {
    if ($selector.length) {
      $selector.removeAttr('data-boost-image-loading-animation')
    }
  }

  // Fix Scroll Position
  ProductList.prototype.afterRender = function () {
    const grid = document.querySelector('[data-collection-grid]')
    if (grid) {
      grid.classList.add('boost-pfs-filter-product-loading')
      setTimeout(() => {
        window.scrollTo(0, 0)
        grid.classList.remove('boost-pfs-filter-product-loading')
      }, 500)
    }
  }

  window.addEventListener('load', () => {
    lowerCaseOptions()
  })

  function injectCallout () {
    const collectionCallout = document.querySelector('[data-collection-callout]')
    const collectionGrid = document.querySelector('[data-collection-grid]')

    if (collectionCallout && collectionGrid) {
      const collectionItems = collectionGrid.querySelectorAll('[data-collection-item]')
      const calloutClone = collectionCallout.cloneNode(true)
      const fourthItem = collectionGrid.children?.item(3)

      if (fourthItem) {
        fourthItem.parentNode.insertBefore(calloutClone, fourthItem)
      } else {
        collectionGrid.append(calloutClone)
      }

      const newCollectionCallout = collectionGrid.querySelector('[data-collection-callout]')

      if (newCollectionCallout) {
        newCollectionCallout.classList.remove('hide')
      }
    }
  }

  function lowerCaseOptions () {
    setTimeout(() => {
      const boostSwatches = document.querySelectorAll('.boost-pfs-filter-option-item-list-swatch li')

      if (!boostSwatches.length) { return }

      boostSwatches.forEach((swatch) => {
        const optionText = swatch.querySelector('.boost-pfs-filter-option-value')

        if (!optionText) { return }
        optionText.innerHTML = optionText.innerHTML.toLowerCase()
      })
    }, 0)
  }

  FilterResult.prototype.render = function () {
    injectCallout()
    lowerCaseOptions()
  }

  FilterResult.prototype.afterRender = function () {
    // Automatically select sort by published date
    const sortParam = new URL(window.location.href).searchParams.get('sort')
    const sortByPublishedDateButton = document.querySelector('[data-sort="extra-sort1-descending"]')
    const defaultCollectionSort = (document.querySelector('[data-default-sort]') === null) ? null : document.querySelector('[data-default-sort]').getAttribute('data-default-sort')
    if (sortParam == null && sortByPublishedDateButton !== null && defaultCollectionSort === 'created-descending') {
      FilterApi.setParam('sort', 'extra-sort1-descending')
      FilterApi.setParam('page', 1)
      FilterApi.applyFilter('sort')
    }

    if (window.location.href.indexOf('/collections/') === -1) { return }

    const collectionItems = document.querySelectorAll('[data-collection-item]')

    collectionItems.forEach((collectionItem) => {
      const handle = collectionItem.getAttribute('data-handle')
      const collectionItemCustomContent = collectionItem.querySelector('[data-collection-item-custom-content]')
      const collectionItemTop = collectionItem.querySelector('[data-collection-item-top]')

      if (window.location.href.indexOf('?event-planner-collection=true') >= 0) {
        const collectionItemLinks = collectionItem.querySelectorAll('[data-collection-item-link]')
        const collectionHandle = window.location.href.split('/collections/')[1].split('?')[0]
        collectionItemLinks.forEach((collectionItemLink) => {
          let href = collectionItemLink.getAttribute('href')
          if (href.indexOf('/collections/') === -1) {
            href = `/collections/${collectionHandle}${href}`
          }
          if (href.indexOf('view=event') === -1) {
            href += (href.indexOf('?') === -1 ? '?' : '&') + 'view=event'
          }
          collectionItemLink.setAttribute('href', href)
        })
      }

      fetch(`${window.location.pathname}/products/${handle}?view=collection-item`, {
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'xmlhttprequest',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: 0
        }
      }).then((response) => {
        return response.text()
      }).then((html) => {
        const responseDOMParser = new window.DOMParser()
        const responseDocument = responseDOMParser.parseFromString(html, 'text/html')
        const responseDocumentContent = responseDocument.querySelector('body').innerHTML
        const responseDocumentSwatches = responseDocument.querySelector('[data-collection-item-swatches-wrapper]')
        const responseDocumentPromotion = responseDocument.querySelector('[data-promotion-element]')
        const responseDocumentHideSaleBadge = responseDocument.querySelector('[data-hide-sale-badge]')
        const responseDocumentLoggedInDiscount = responseDocument.querySelector('[data-logged-in-discount]')
        const responseDocumentLoggedInBadge = responseDocument.querySelector('[data-logged-in-badge]')
        const responseDocumentOnlineExclusive = responseDocument.querySelector('[data-collection-item-online-exclusive]')

        if (!responseDocumentSwatches && !responseDocumentPromotion && !responseDocumentLoggedInDiscount && !responseDocumentHideSaleBadge && !responseDocumentOnlineExclusive) { return }

        collectionItemCustomContent.innerHTML = responseDocumentContent
        if (collectionItemCustomContent.querySelector('[data-site-content]') !== null) {
          collectionItemCustomContent.remove()
          return
        }

        if (responseDocumentLoggedInDiscount) {
          const collectionItemPrice = collectionItem.querySelector('.collection__item-price')

          if (collectionItemPrice) {
            collectionItemPrice.innerHTML = responseDocumentLoggedInDiscount.innerHTML
          }
        }

        if (responseDocumentLoggedInBadge) {
          const collectionItemTopHolder = collectionItem.querySelector('.collection-item__top-holder')
          const collectionItemBadge = collectionItem.querySelector('.collection__item-badge')

          if (collectionItemBadge) {
            collectionItemBadge.remove()
          }

          if (collectionItemTopHolder) {
            const newElement = document.createElement('div')
            newElement.innerHTML = responseDocumentLoggedInBadge.innerHTML
            collectionItemTopHolder.appendChild(newElement)
          }
        }

        if (responseDocumentHideSaleBadge) {
          const saleBadge = collectionItem.querySelector('[data-collection-item-badge]')

          if (saleBadge && saleBadge.classList.contains('badge-sale')) {
            saleBadge.classList.add('hide')
          }
        }

        const collectionItemPromotions = collectionItem.querySelectorAll('[data-promotion-element]')
        if (collectionItemTop !== null && collectionItemPromotions !== null) {
          let index = 1
          /* Boost 213543 */
          collectionItemPromotions.forEach((collectionItemPromotion) => {
            if (!collectionItemTop.querySelector('[data-promotion-element]')) {
              collectionItemPromotion.querySelector('[data-promotion]').classList.add(`promotion--${index}`)
              if (window.location.href.indexOf('event-planner-collection') >= 0) {
                collectionItemPromotion.classList.add('hide')
              }
              index += 1
              collectionItemTop.append(collectionItemPromotion)
            }
          })
        }

        if (responseDocumentSwatches) {
          const swatchesWrapper = collectionItemCustomContent.querySelector('[data-collection-item-swatches-wrapper]')
          const swatches = swatchesWrapper.querySelectorAll('[data-collection-item-swatch]')
          let swatchMax = 4
          swatches.forEach((swatch) => {
            const swatchValue = swatch.getAttribute('data-value')
            const collectionItemLink = collectionItem.querySelector('[data-collection-item-link]')

            if (swatch.classList.contains('active')) {
              const swatchValueCapitalized = swatchValue
                .split(' ')
                .map(word => {
                  return word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ''
                })
                .join(' ')

              // console.log('Setting swatch value to:', swatchValueCapitalized)
              collectionItem.setAttribute('data-collection-item-swatch-value', swatchValueCapitalized)
            }

            // check if there's a view event in the swatch
            const collectionHandle = window.location.href.split('/collections/')[1].split('?')[0]
            let linkDestination = swatch.getAttribute('data-variant-url')
            if (linkDestination.indexOf('/collections/') === -1) {
              linkDestination = `/collections/${collectionHandle}${linkDestination}`
            }
            if (window.location.href.indexOf('?event-planner-collection=true') >= 0 && linkDestination.indexOf('view=event') === -1) {
              linkDestination += (linkDestination.indexOf('?') === -1 ? '?' : '&') + 'view=event'
            }
            swatch.setAttribute('data-variant-url', linkDestination)
            collectionItemLink.href = linkDestination
          })

          if (swatches.length === 1) {
            swatchesWrapper.classList.add('hide')
          }

          if (window.matchMedia('(min-width: 750px)').matches) {
            swatchMax = 5
          }

          if (swatches.length >= (swatchMax + 1)) {
            const swatchToggle = swatchesWrapper.querySelector('[data-collection-item-swatch-toggle]')

            swatches.forEach((swatch, index) => {
              if (index < swatchMax) { return }
              swatch.classList.add('hide')
              swatch.setAttribute('data-is-hidden', true)
            })

            swatchToggle.classList.remove('hide')

            swatchToggle.addEventListener('click', () => {
              const hiddenSwatches = swatchesWrapper.querySelectorAll('[data-is-hidden]')

              swatchToggle.classList.add('hide')

              swatches.forEach((swatch, index) => {
                swatch.classList.remove('hide')
              })

              hiddenSwatches[swatchMax - 1].focus()
            })
          }

          if (swatchesWrapper.hasAttribute('data-product-variants-json')) {
            const variantData = JSON.parse(swatchesWrapper.getAttribute('data-product-variants-json'))
            let swatchCount = 0

            swatches.forEach((swatch) => {
              const swatchValue = swatch.getAttribute('data-value')

              swatch.classList.add('hide')

              variantData.forEach((variantObject) => {
                if (variantObject.option1 !== swatchValue || variantObject.status === 'No') { return }
                swatch.classList.remove('hide')
              })
            })

            swatches.forEach((swatch) => {
              if (swatch.classList.contains('hide')) { return }
              swatchCount += 1
            })

            if (swatchCount === 1) {
              swatchesWrapper.classList.add('hide')
            }
          }

          swatchArrange()

          function swatchArrange () {
            const holders = document.querySelectorAll('[data-collection-item-associated-swatches]')

            holders.forEach((holder) => {
              const swatches = Array.from(holder.querySelectorAll('[data-collection-item-swatch]'))
              const swatchToggle = holder.querySelector('[data-collection-item-swatch-toggle]')

              holder.innerHTML = ''

              const sortedSwatches = swatches.sort((a, b) => {
                const aValue = a.getAttribute('data-collection-item-swatch')
                const bValue = b.getAttribute('data-collection-item-swatch')
                if (aValue < bValue) { return -1 }
                if (aValue > bValue) { return 1 }
                return 0
              })

              sortedSwatches.forEach((swatch, index) => {
                holder.append(swatch)

                if (index >= 5) {
                  swatch.classList.add('hide')
                } else {
                  swatch.classList.remove('hide')
                }
              })

              if (swatchToggle) {
                holder.append(swatchToggle)
              }
            })
          }
        }

        const collectionItemSwatches = collectionItem.querySelectorAll('[data-collection-item-swatch]')

        if (collectionItemSwatches.length >= 2) {
          collectionItemSwatches.forEach((collectionItemSwatch) => {
			  const tempTitle = jQ(collectionItemSwatch).closest('.collection__item').find('.collection__item-title').text()
			  const tempSwatchTitle = collectionItemSwatch.getAttribute('data-collection-item-swatch')
			  if (tempTitle.includes(tempSwatchTitle)) {
              collectionItemSwatch.click()
			  }
			  // if (!collectionItemSwatch.classList.contains('active')) { return }
			  // collectionItemSwatch.click()
          })
        }

        return null
      }).catch((error) => {
        console.log(error)
      })
    })
  }
})()
